import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import CPNavbar from './CPNavbar/CPNavbar';

const CPGuard = ({ children }) => {
  const navigate = useNavigate();
  const token    = localStorage.getItem('cp_token');

  const handleLogout = () => {
    localStorage.removeItem('cp_token');
    localStorage.removeItem('cp_admin');
    navigate('/cp/login', { replace: true });
  };

  if (!token) return <Navigate to="/cp/login" replace />;

  return (
    <CPNavbar onLogout={handleLogout}>
      {children}
    </CPNavbar>
  );
};

export default CPGuard;
